import React from 'react';
import LegalPage from './LegalPage';
import { imprintContent } from '../data/legalContent';

const Imprint = () => (
  <LegalPage title="Imprint" eyebrow="Metaxu One Private Limited" content={imprintContent} />
);

export default Imprint;
